import { render, staticRenderFns } from "./RecorderPauseButton.vue?vue&type=template&id=97f284a6&scoped=true"
import script from "./RecorderPauseButton.vue?vue&type=script&lang=ts"
export * from "./RecorderPauseButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f284a6",
  null
  
)

export default component.exports